import { type MutationPayload } from 'vuex';
import Store from '../stores/store';
import { AlertNotificationModuleConstant } from '../constants';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export default class AlertNotificationStore implements ltFramework.IAlertNotificationStore {
	public getInitialData(): ltFramework.IAlertNotification[] {
		return (Store.state as ltFramework.IStoreState).alertNotificationModule.alertNotifications;
	}

	public initialize(clubId?: number): Promise<void> {
		return Store.dispatch(
			AlertNotificationModuleConstant.name
			+ '/'
			+ AlertNotificationModuleConstant.action.initialize,
			clubId
		);
	}

	public open(alertNotification: ltFramework.IAlertNotification): Promise<void> {
		return Store.dispatch(
			AlertNotificationModuleConstant.name + '/' + AlertNotificationModuleConstant.action.open,
			alertNotification
		);
	}

	public close(alertNotification: ltFramework.IAlertNotification): Promise<void> {
		return Store.dispatch(
			AlertNotificationModuleConstant.name + '/' + AlertNotificationModuleConstant.action.close,
			alertNotification
		);
	}

	public listen(callback: (state: ltFramework.IAlertNotification[]) => void): () => void {
		return Store.subscribe((mutation: MutationPayload, state: ltFramework.IRootState) => {
			if (mutation.type.includes(AlertNotificationModuleConstant.name + '/')) {
				callback((state as ltFramework.IStoreState).alertNotificationModule.alertNotifications);
			}
		});
	}
}
